import { RoleType } from "../../models/modelTypes";
import { getData } from "./rest";

export const list = async (): Promise<{ items: RoleType[]; total: number }> => {
    return getData(`/role`);
};
